'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.autobind = autobind;
exports.alias = alias;
exports.aliasWhen = aliasWhen;
exports.serverOnly = serverOnly;
exports.clientOnly = clientOnly;
exports.memoize = memoize;
exports.prop = prop;
exports.transform = transform;

var _exports = require('exports');

var _exports2 = _interopRequireDefault(_exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function autobind(target, name, descriptor) {
	return {
		enumerable: descriptor.enumerable,
		configurable: descriptor.configurable,
		get: function get() {
			if (this === target) return descriptor.value;

			Object.defineProperty(this, name, { configurable: true, writable: true, value: descriptor.value.bind(this) });
			return this[name];
		},
		set: function set(value) {
			delete this[name];
			Object.defineProperty(this, name, { configurable: true, writable: true, value: value, enumerable: true });
		}
	};
}

function alias(tname) {
	return function (target, name, descriptor) {
		descriptor = Object.assign({}, descriptor);
		delete descriptor.value;
		delete descriptor.writable;
		delete descriptor.initializer;
		descriptor.enumerable = false;
		descriptor.get = Function('return this.' + tname);
		descriptor.set = Function('value', 'this.' + tname + ' = value');
		return descriptor;
	};
}

function aliasWhen(name, test) {
	return function (target, innerName, descriptor) {
		if (test) {
			Object.defineProperty(target, name, {
				enumerable: false,
				configurable: true,
				get: function get() {
					return this[innerName];
				},
				set: function set(value) {
					Object.defineProperty(this, name, { enumerable: true, configurable: true, writable: true, value: value });
				}
			});
		}
		return descriptor;
	};
}

function serverOnly(name) {
	return aliasWhen(name, !!_exports2.default.Channel);
}

function clientOnly(name) {
	return aliasWhen(name, !_exports2.default.Channel);
}

function memoize(target, name, descriptor) {
	return {
		enumerable: false,
		configurable: true,
		get: function get() {
			var value;
			if (descriptor.initializer) value = descriptor.initializer.call(this);else if (descriptor.value) value = descriptor.value;else if (descriptor.get) value = descriptor.get.call(this);

			Object.defineProperty(this, name, { enumerable: false, configurable: true, writable: true, value: value });
			return value;
		},
		set: function set(value) {
			Object.defineProperty(this, name, { enumerable: false, configurable: true, writable: true, value: value });
		}
	};
}

function prop() {
	for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		args[_key] = arguments[_key];
	}

	if (args.length == 3 || args.length == 4) {
		var target = args[0],
		    name = args[1],
		    descriptor = args[2];

		var targetName = args[3] || name;
		return {
			enumerable: false,
			configurable: true,
			get: function get() {
				return this.props[targetName];
			}
		};
	}
	return function () {
		for (var _len2 = arguments.length, a2 = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
			a2[_key2] = arguments[_key2];
		}

		return prop.apply(undefined, _toConsumableArray(a2.concat(args)));
	};
}

function transform(sourceName, transform) {
	return function (target, name, descriptor) {
		var getter = Function('', 'return this.' + sourceName);
		return {
			enumerable: false,
			configurable: true,
			get: function get() {
				// debug(`transform() decorator: transforming this.${sourceName}`)
				return transform(getter.call(this));
			}
		};
	};
}